const linkedinProfile = [
    '.pv-top-card--experience-list-item', // Contact Page - Contact Experience (Lusha Contacts)
    '#experience-section', // Contact Page - Contact Experience (Lusha Contacts)
    '.top-card__right-column-link', // Public Contact Page - Contact Information (Lusha Contacts)
    '.experience pp-section', // Public Contact Page - Contact Experience (Lusha Contacts)
    'a[data-field="experience_company_logo"]', // Contact Page - Contact Experience (Lusha Contacts) (LinkedinV5) (13.04.2023)
    '.experience-item', // Public Contact Page - Experience Item (13.04.2023),
    '.zPzTnPKsowtdkbFmfiypMJULUllXqOkQp',
];
const linkedinBulk = [
    '.search-results-container', // Search People Page - Results container (Bulk Enrich)
    '[data-sdui-screen="com.linkedin.sdui.flagshipnav.search.SearchResultsPeople"]',
];
const linkedinCompany = [
    '.org-top-card.artdeco-card .relative', // Company page
    '.org-top-card-listing',
];
export const LINKEDIN_INDICATORS_BY_CONTEXT_TYPE = {
    profile: linkedinProfile,
    bulk: linkedinBulk,
    company: linkedinCompany,
    unknown: [...linkedinProfile, ...linkedinBulk, ...linkedinCompany],
};
